module.exports = __webpack_public_path__ + "static/media/pinBlue.dc280589.svg";